export default "/images/701190aae355a079a6bc8429c6ac105a.avif";